// ----------------------------------------------------------------------------
// Template: Search
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/pagination/pagination';
import 'snippets/search-form/search';

import 'sections/header/header';
import 'sections/page-header/page-header';
import 'sections/footer/footer';
import 'sections/country-modal/country-modal';

// Styles
import './_search.scss';
